import { createSafeContext } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { FormValues, StatusFormMapping } from '../utils';

interface SimulationFormContextValue {
  form: UseFormReturnType<FormValues>;
  currentFormConfig: StatusFormMapping | undefined;
  hasForm: boolean;
}

export const [SimulationFormProvider, useSimulationFormContext] = createSafeContext<SimulationFormContextValue>(
  'SimulationFormContext not found',
);
